import {
    useCallback,
    useEffect,
    useState
} from 'react';
import EStyleSheet from 'react-native-extended-stylesheet';

import {
    FlatList,
    Text,
    TouchableOpacity,
    View
} from '../../../common';
import { COLORS } from '../../../styles/colors';


export const styles = EStyleSheet.create({
    text: {
        fontSize: 16,
        color: '#000000',
    },
    selected: {
        color: COLORS.MAIN,
    },
    item: {
        // flex: 1,
        flexDirection: 'column',
        borderWidth: 0,
        borderColor: COLORS.BORDER_GRAY,
    },
    container: {
        // flex: 1,
        flexDirection: 'column',
        borderColor: 'blue',
        borderWidth: 0,
        padding: 2,
        margin: 2,
    },
});
export const DeviceListItem = ({
    item: {
        deviceId,
        deviceName,
        deviceModel,
    } = {},
    isSelected,
}) => <View style={[ styles.item ]}>
    <View>
        <Text style={[ styles.text, isSelected ? styles.selected : {} ]}>ID: {deviceId ?? 'No ID'}</Text>
    </View>
    <View>
        <Text style={[ styles.text, isSelected ? styles.selected : {} ]}>NAME: {deviceName ?? 'No name'}</Text>
    </View>
    <View>
        <Text style={[ styles.text, isSelected ? styles.selected : {} ]}>MODEL: {deviceModel ?? 'No model'}</Text>
    </View>
</View>;
export const DevicesList = ({
    data: srcData,
    selected,
    onSelect,
}) => {
    const [ data, setData ] = useState([]);

    useEffect(() => {
        setData(srcData);
    }, [ srcData ]);

    const clickHandler = useCallback(item => () => {
        console.log('device select click handler', {
            item,
            selected,
        });
        if (item?.deviceId && item?.deviceId !== selected?.deviceId) {
            console.log('Set selected', item);
            onSelect?.(item);
        }
    }, [ onSelect, selected ]);
    return <View style={[ styles.container ]}>
        <Text>Список устройств:</Text>
        <FlatList
            data={data}
            renderItem={({ item }) => <TouchableOpacity
                key={item?.id}
                onPress={clickHandler(item)}
                style={[ styles.item ]}><DeviceListItem
                    item={item}
                    isSelected={item?.deviceId === selected?.deviceId}/></TouchableOpacity>}/>
    </View>;
};
